/** Wall-clock session length for delivery partner app (frontend-enforced). */
export const DP_SESSION_DURATION_MS = 24 * 60 * 60 * 1000;

const DP_SESSION_START_KEY = 'dpSessionStartAt';

export function startDeliverySession(): void {
  localStorage.setItem(DP_SESSION_START_KEY, String(Date.now()));
}

export function clearDeliverySessionClock(): void {
  localStorage.removeItem(DP_SESSION_START_KEY);
}

export function getDeliverySessionStart(): number | null {
  const raw = localStorage.getItem(DP_SESSION_START_KEY);
  if (raw == null || raw === '') return null;
  const n = Number.parseInt(raw, 10);
  return Number.isFinite(n) ? n : null;
}

export function isDeliverySessionExpired(): boolean {
  const start = getDeliverySessionStart();
  if (start == null) return false;
  return Date.now() - start >= DP_SESSION_DURATION_MS;
}
